import React from "react";
import styled from "styled-components";
import Title from "./Title";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

const ChannelSearch = ({
    channelTitleInput,
    channelTitleInputValue,
    channelTitleSubmit,
    resetCondition,
    messages,
    classes
}) => (
    <ChannelWrap>
        <Title>{messages.rank_now}</Title>
        <Paper className={classes.root} elevation={1}>
            <InputBase
                className={classes.input}
                onChange={channelTitleInput}
                value={channelTitleInputValue}
                onKeyPress={e => {
                    if (channelTitleInputValue !== "") {
                        e.key === "Enter" && channelTitleSubmit();
                    } else e.key === "Enter" && resetCondition();
                }}
                type="text"
                placeholder={messages.rank_input}
            />
            <IconButton
                onClick={() => channelTitleSubmit()}
                className={classes.iconButton}
                aria-label="Search"
            >
                <SearchIcon />
            </IconButton>
        </Paper>
    </ChannelWrap>
);

ChannelSearch.propTypes = {
    classes: PropTypes.object.isRequired
};
const styles = {
    root: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        marginLeft: "8px",
        border: "1px solid #ccc",
        boxShadow: "none",
        "@media (max-width: 665px)": {
            fontSize: "16px",
            marginLeft: "0"
        }
    },
    input: {
        marginLeft: 8,
        flex: 1,
        color: "#979797",
        fontSize: "14px",
        padding: "0 5px",
        "@media (max-width: 665px)": {
            fontSize: "16px"
        }
    },
    iconButton: {
        padding: 6
    }
};
export default withStyles(styles)(ChannelSearch);

const ChannelWrap = styled.div`
    display: flex;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #e6e6e6;
    @media (max-width: 900px) {
        align-items: initial;
        flex-direction: column;
        ${Title} {
            margin-bottom: 10px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/Ranking/RankCondition/ChannelSearch.js